function DateTime() {
    const date = new Date();
    const time = date.getHours() + ':' + String(date.getMinutes()).padStart(2, "0");
    const fullDate = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
    return  (
        <div className="information_card">
            <h3>Time & Date</h3>
            <p className="information" data-submitted={time + ' - ' + fullDate}>{time} - {fullDate}</p>
        </div>
    )
}

export default DateTime;